import React, { useState, useEffect } from 'react';
import { ComposedChart, Line, Bar, XAxis, YAxis, ResponsiveContainer, LabelList, PieChart, Pie, Cell } from 'recharts';
import BackButton from '../BackButton';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import * as actions from '../../actions/index';
import { withRouter } from 'react-router-dom';
import { styles } from './DeepLink.styles';
import Paper from '../Paper';
import IconButton from '../IconButton';
import { UNIT, mainColor } from '../../constants/theme';
import { CAMPAIGN_TYPE, ANALYTICS, BRANCH_EVENTS, CHART_COLORS, ANALYTICS_TYPES } from '../../constants';
import { ExpandMore, ExpandLess, FileCopy } from '@material-ui/icons';
import { Divider } from '@material-ui/core';
import { handleToggle, copyLink, handleChangeTypes, addDeepLink, extractEventCounts, onSelectDate } from './DeepLink.services';
import AddIcon from '@material-ui/icons/Add';
import { Grid } from '@material-ui/core';
import Modal from '../Modal';
import Input from '../Input';
import Select from '../Select';
import _ from 'lodash';
import { getDeepLinks } from '../../apis/backend';
import Spinner from '../Spinner';
import DateRangePicker from '../DateRangePicker'; import { getInitialDateRange } from '../../utils/suitableDate';
import { formattedValue } from '../../utils/tools';
import moment from 'moment';
import { marketing } from '../../constants/mainViewList'
interface DeepLinkComponentProps {
    history: any;
    classes: any;
    openErrorModal: any;
}

const DeepLinkComponent: React.FC<DeepLinkComponentProps> = ({ classes, history = {}, openErrorModal }) => {
    const [isAddDeepLink, setIsAddDeepLink] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [channel, setChannel] = useState('');
    const [campaign, setCampaign] = useState('');
    const [deepLinks, setDeepLinks] = useState<Record<string, any> | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const deepLinkIds = _.keys(deepLinks);
    const [expandedDeepLinks, setExpandedDeepLinks] = useState({});
    const [deepLinksAnalytics, setDeepLinksAnalytics] = useState<Record<string, any> | null>(null);
    const [isLoadingAnalytics, setIsLoadingAnalytics] = useState(false);
    const [openedDeepLink, setOpenedDeepLink] = useState({ creationDate: '', id: '' });
    const [dateRange, setDateRange] = useState(getInitialDateRange());
    const maxDate = moment().subtract(2, 'days');
    let latestCreationDate: Date | undefined = undefined;
    useEffect(() => {
        const fetchAndSortDeepLinks = async () => {
            try {
                const deeplinks = await getDeepLinks();
                const sortedDeepLinks = _.keys(deeplinks)
                    .sort((a, b) => moment(deeplinks[b].creationDate).valueOf() - moment(deeplinks[a].creationDate).valueOf())
                    .reduce((obj, cur) => ({ ...obj, [cur]: deeplinks[cur] }), {});
                if (!isAddDeepLink && deeplinks) {
                    const firstKey = Object.keys(sortedDeepLinks)[0];
                    handleToggle(
                        setExpandedDeepLinks,
                        firstKey,
                        sortedDeepLinks,
                        dateRange.startDate,
                        dateRange.endDate,
                        setDeepLinksAnalytics,
                        setIsLoadingAnalytics,
                        openErrorModal,
                        true,
                        setOpenedDeepLink
                    );
                }
                setDeepLinks(sortedDeepLinks);
            } catch (error) {
                console.error('Erreur lors de la récupération des deep links:', error);
                openErrorModal('Erreur lors de la récupération des deep links.');
                setIsLoadingAnalytics(false);
                setDeepLinksAnalytics([]);
                setDeepLinks([]);
            }
        };

        fetchAndSortDeepLinks();
        setIsAddDeepLink(false);
    }, [isAddDeepLink]);


    const renderComposedChart = (deepLinkAnalytic, type, title, description = '') => {
        const events = extractEventCounts(deepLinkAnalytic, type);

        const filterEvents = (condition) => events.filter(condition);
        const eventCounts = type === ANALYTICS_TYPES.HAS_NOT_APPLICATION
            ? events
            : type === ANALYTICS_TYPES.HAS_NOT_ACCOUNT
                ? filterEvents(analytic => analytic?.eventType !== BRANCH_EVENTS.INSTALL)
                : filterEvents(analytic => analytic?.eventType !== BRANCH_EVENTS.INSTALL && analytic?.eventType !== BRANCH_EVENTS.REGISTRATION);

        const totalClicks = eventCounts.find(event => event.eventType === BRANCH_EVENTS.CLICK)?.count || 0;
        const totalRegistrations = events.find(event => event.eventType === BRANCH_EVENTS.REGISTRATION)?.count || 0;
        const totalNewsletterSubscribers = events.find(event => event.eventType === BRANCH_EVENTS.NEWSLETTER)?.count || 0
        const dataForNewsletterChart = [
            { eventType: BRANCH_EVENTS.REGISTRATION, count: totalRegistrations, name: ANALYTICS.complete_registration },
            { eventType: 'totalNewsletterSubscribers', count: totalNewsletterSubscribers, name: 'Adhérents' }
        ];

        const allZero = dataForNewsletterChart.every(entry => entry.count === 0);
        const hasZero = dataForNewsletterChart.some(entry => entry.count === 0);

        const renderLabel = (entry, index) => (
            <div key={`label-${index}`} style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
                <div
                    className={classes.circleLabel}
                    style={{
                        backgroundColor: CHART_COLORS[index % CHART_COLORS.length],
                        border: 'none',
                        minWidth: UNIT * 0.75
                    }}
                />
                <span>{entry.name}</span>
            </div>
        );

        const renderPieChart = () => (
            <ResponsiveContainer width={200} height={200}>
                <PieChart>
                    <Pie
                        data={allZero ? [{ name: 'No Data', count: 1 }] : dataForNewsletterChart}
                        dataKey="count"
                        cx="50%"
                        cy="50%"
                        outerRadius={70}
                        fill="transparent"
                        stroke='none'
                        strokeWidth={0}
                        labelLine={false}
                        label={({ cx, cy, midAngle, innerRadius, outerRadius, value, index }) => {
                            if (value === 0) return null;
                            const RADIAN = Math.PI / 180;
                            const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
                            const x = (hasZero || allZero) ? cx : cx + radius * Math.cos(-midAngle * RADIAN);
                            const y = (hasZero || allZero) ? cy : cy + radius * Math.sin(-midAngle * RADIAN);
                            const percentage = totalRegistrations > 0 ? formattedValue((value / totalRegistrations) * 100) : 0;
                            return (
                                <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central">
                                    {`${allZero ? 0 : value}`}
                                    {index !== 0 && (
                                        <tspan x={x} y={y + 15} fontSize="9">
                                            {`(${percentage}%)`}
                                        </tspan>
                                    )}

                                </text>
                            );
                        }}
                    >
                        {allZero
                            ? <Cell key="gray-cell" fill="#d3d3d3" />
                            : dataForNewsletterChart.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={CHART_COLORS[index % CHART_COLORS.length]} />
                            ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
        );

        const renderBarChart = () => (
            <ResponsiveContainer height={200}>
                <ComposedChart data={eventCounts}>
                    <XAxis
                        dataKey="eventType"
                        tickFormatter={(value) => ANALYTICS[value] || value}
                        tick={{ fontWeight: 'bolder', fontFamily: '"Roboto", sans-serif', color: 'black' }}
                    />
                    <YAxis hide />
                    <Bar dataKey="count" barSize={100} fill="#2AA95E">
                        <LabelList
                            dataKey="count"
                            position="inside"
                            content={({ x, y, width, height, value, index }) => {
                                const percent = value && totalClicks > 0 ? formattedValue((value / totalClicks) * 100) : 0;
                                const cx = x + width / 2;
                                const cy = y + height / 2;
                                const isLargeBar = height > 20;
                                const textColor = isLargeBar ? '#fff' : '#000';
                                const dyValue = isLargeBar ? -10 : -45;
                                const dyPercent = isLargeBar ? 10 : -20;

                                return (
                                    <g>
                                        <text x={cx} y={cy} dy={dyValue} textAnchor="middle" fill={textColor}>
                                            {value}
                                        </text>
                                        {index !== 0 && (
                                            <text x={cx} y={cy} dy={dyPercent} textAnchor="middle" fill={textColor}>
                                                ({percent}%)
                                            </text>
                                        )}
                                    </g>
                                );
                            }}
                        />
                    </Bar>
                    <Line type="linear" dataKey="count" stroke="#228B22" dot={false} isAnimationActive connectNulls />
                    <Line type="linear" dataKey="bottom" stroke="#228B22" dot={false} connectNulls />
                </ComposedChart>
            </ResponsiveContainer>
        );

        return (
            <div className={classes.chartPaperStyle}>
                {<> <p style={{ color: 'black', textAlign: 'center', fontSize: 14, fontWeight: 'bold' }}>{title}</p>
                    <p className='m-0 h6' style={{ textAlign: 'center', fontSize: UNIT * 0.625 }}>{description}</p></>}
                <div className="d-flex align-items-center justify-content-center pt-3">
                    {type === ANALYTICS_TYPES.ACCEPT_NEWSLETTER ? (
                        <div className="pie align-items-center justify-content-center">
                            <div className="d-flex flex-column justify-content-center">
                                {dataForNewsletterChart.map(renderLabel)}
                            </div>
                            {renderPieChart()}
                        </div>
                    ) : renderBarChart()}
                </div>
            </div>
        );
    };
    if (deepLinks && _.values(deepLinks).length > 0) {
        latestCreationDate = moment(_.values(deepLinks)[_.values(deepLinks).length - 1].creationDate).toDate();
    }
    const renderModal = () => {
        return (
            <Modal
                color='secondary'
                btnTxt='Enregistrer'
                title='Nouveau lien magique'
                loading={isLoading}
                header
                showCancelBtn
                onClick={() => {
                    addDeepLink(campaign, channel, setIsLoading, openErrorModal, setIsOpen, setChannel, setCampaign, setIsAddDeepLink)
                }}
                isOpen={isOpen}
                handleClose={() => { setIsOpen(false); setChannel(''); setCampaign('') }}
            >
                <div className={classes.modal}>
                    <Input
                        margin='dense'
                        id='name'
                        label={`Nom de la compagne`}
                        type='text'
                        placeholder='Emballage'
                        value={campaign}
                        onChange={e => setCampaign(e.target.value)}
                        autoFocus
                        fullWidth
                    />
                    <Select
                        as='select'
                        custom
                        fullWidth
                        className='mt-3 w-100'
                        label="Type de la compagne"
                        id='type'
                        onChange={e => handleChangeTypes(e, setChannel)}
                        value={channel}
                        name='type'
                        placeholder='Sélectionner un type de compagne'
                    >
                        <option value='' disabled>
                            À choisir
                        </option>
                        {_.map(CAMPAIGN_TYPE, (value, key) => (
                            <option key={key} value={key}>
                                {value}
                            </option>
                        ))}
                    </Select>
                </div>
            </Modal>
        );
    }

    return (
        <div className='col-12 p-4 px-0'>
            <div className="container-fluid p-3">
                <div className="row align-items-center">
                    <div className="col-lg-7 col-md-6 col-sm-12 mb-2 pl-0">
                        <div className="d-flex flex-wrap align-items-center justify-content-start">
                            <BackButton
                                className='p-0'
                                onClick={() => history.goBack()}
                                title={marketing.deepLinks.text}
                                subtitle={marketing.deepLinks.description}
                            />
                        </div>
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-12 d-flex align-items-center justify-content-end">
                        <div className="d-flex align-items-center">
                            <DateRangePicker
                                classes={classes}
                                className='pr-2'
                                dateRange={dateRange}
                                onSelectDate={dateRange => {
                                    onSelectDate(dateRange, setDateRange, openedDeepLink.id, setIsLoadingAnalytics, setDeepLinksAnalytics, openErrorModal, setExpandedDeepLinks, deepLinks, setOpenedDeepLink);
                                }}
                                deepLinkCreationDate={moment(openedDeepLink.creationDate).toDate()}
                                minDate={moment(latestCreationDate).toDate()}
                                maxDate={maxDate.toDate()}
                                disabled={!deepLinks || _.size(deepLinks) === 0}
                            />



                            <IconButton onClick={() => setIsOpen(true)} title="Ajouter un nouveau lien magique" style={{ background: '#FFFFFF' }}>
                                <AddIcon className={classes.addIcon} />
                            </IconButton>
                        </div>
                    </div>
                </div>
            </div>
            {deepLinks && deepLinksAnalytics ? (
                _.map(deepLinks, (deeplink, id) => {
                    const { campaign, url, creationDate = moment() } = deeplink;
                    const isExpanded = expandedDeepLinks[id] || false;
                    return (
                        <Paper className={`col-12 px-0 ${isExpanded && 'mb-3'} ${classes.paperStyle} ${id === deepLinkIds[0] ? classes.withTopBorder : id !== deepLinkIds[deepLinkIds.length - 1] ? classes.withoutBorder : classes.withBottomBorder}`} key={id}>
                            <div className="container-fluid px-3 py-1">
                                <div className="row align-items-center">
                                    <div className="col-md-12 col-xs-11">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className={classes.compaignTitle}>
                                                <strong className={`${classes.compaignTitle}`}>{campaign}</strong>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <div className='d-none d-md-block mx-2'>
                                                    <span>Copier le lien</span>
                                                </div>
                                                <div className='pr-md-5 pr-xs-4'>
                                                    <IconButton onClick={() => copyLink(url)} title="Copier le lien">
                                                        <FileCopy className={classes.iconStyle} />
                                                    </IconButton>
                                                </div>
                                                <div>
                                                    Créé le: <strong>{moment(creationDate).locale('fr').format('L')}</strong>
                                                </div>



                                                <IconButton style={{ marginLeft: 10 }} onClick={() => handleToggle(setExpandedDeepLinks, id, deepLinks, dateRange.startDate, dateRange.endDate, setDeepLinksAnalytics, setIsLoadingAnalytics, openErrorModal, false, setOpenedDeepLink)} disabled={isLoadingAnalytics || isExpanded}>
                                                    {isExpanded ? <ExpandLess className={classes.addIcon} /> : <ExpandMore className={classes.addIcon} />}
                                                </IconButton>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {isExpanded && (
                                <>
                                    <div style={{ background: 'rgb(246 246 247)', marginBottom: -UNIT }} className={`${id === deepLinkIds[deepLinkIds.length - 1] && classes.withBottomBorder}`}>
                                        <Divider />
                                        {!isLoadingAnalytics ? (
                                            deepLinksAnalytics && _.size(deepLinksAnalytics) > 0 ? (
                                                _.map(deepLinksAnalytics, deepLinkAnalytic => {
                                                    const { eventDetails = {} } = deepLinkAnalytic;
                                                    const clickEvent = eventDetails.find(event => event.eventType === BRANCH_EVENTS.CLICK) || {};
                                                    const purchaseEvent = eventDetails.find(event => event.eventType === BRANCH_EVENTS.PURCHASE) || {}
                                                    const { totalCountPurchase = 0, totalRevenue = 0 } = purchaseEvent
                                                    const rate = clickEvent.totalUsers > 0 ? formattedValue((totalCountPurchase / clickEvent.totalUsers) * 100) : 0;
                                                    return (
                                                        <div className='px-3 '>
                                                            <div className="title d-flex m-2 align-items-center justify-content-center mt-4 mb-2">
                                                                <div className={`${classes.minSubtitle} ml-3 text`}>
                                                                    <b>Commandes totales:</b> <strong className={classes.minValue}>{totalCountPurchase}</strong>
                                                                </div>
                                                                <div className={`${classes.minSubtitle} mx-3 text`}>
                                                                    <b>Chiffre d'affaires:</b> <strong className={classes.minValue}>{totalRevenue} €</strong>
                                                                </div>
                                                                <div className={`${classes.minSubtitle} mr-3 text`}>
                                                                    <b>Taux de transformation:</b> <strong className={classes.minValue}>{rate} %</strong>
                                                                </div>
                                                            </div>
                                                            <Grid container spacing={3} className='my-1'>
                                                                <Grid item xs={12} sm={12} md={8} lg={8} xl={6}>
                                                                    {renderComposedChart(deepLinkAnalytic, ANALYTICS_TYPES.HAS_NOT_APPLICATION, `Nouvelles installations`, `Utilisateurs n'ayant jamais installé l'application`)}
                                                                </Grid>
                                                                <Grid item xs={12} sm={12} md={4} lg={4} xl={6}>
                                                                    {renderComposedChart(deepLinkAnalytic, ANALYTICS_TYPES.ACCEPT_NEWSLETTER, `Utilisateurs ayant adhéré à la Newsletter lors de l'inscription`)}
                                                                </Grid>
                                                            </Grid>
                                                            <Grid container spacing={3} className='mt-1'>
                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                    {renderComposedChart(deepLinkAnalytic, ANALYTICS_TYPES.HAS_NOT_ACCOUNT, `Nouvelles inscriptions`, `Utilisateurs pas encore inscrits`)}
                                                                </Grid>
                                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                    {renderComposedChart(deepLinkAnalytic, ANALYTICS_TYPES.HAS_ACCOUNT, `Suivi des utilisateurs existants`, `Utilisateurs déjà inscrits sur l'application`)}
                                                                </Grid>
                                                            </Grid>
                                                            <div className='pb-2 pt-3 text-secondary'>
                                                                Les données collectées ci-dessus ne sont comptabilisées qu'une seule fois par appareil.
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <div style={{ padding: UNIT * 5, textAlign: 'center', color: '#888' }}>
                                                    Aucune donnée disponible pour ce lien.
                                                </div>
                                            )
                                        ) : (
                                            <div style={{
                                                padding: UNIT * 5,
                                                textAlign: 'center',
                                                color: `rgba(${mainColor.rgb}, 1)`,
                                                alignSelf: 'center'
                                            }}>
                                                <Spinner />
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                        </Paper>

                    );
                })
            ) : (
                <div style={{ padding: UNIT * 5, textAlign: 'center', color: `rgba(${mainColor.rgb}, 1)`, alignSelf: 'center' }}>
                    <Spinner />
                </div>
            )}

            {renderModal()}

        </div>
    );
}


function mapStateToProps({ }) { }

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(DeepLinkComponent)));
